export default __webpack_public_path__ + "static/media/blankslate-loading-icon.84c7803e.svg";